<template>
    <div>
        <div class="header-intrebari">
            <div class="hero">
                <div class="background background--cover background--bottom hero__background">
                    <div class="background__image lazyloaded">&nbsp;</div>
                </div>
                <div class="hero__band">
                    <div class="hero__message">
                        <h1 class="heading heading--1 heading--light heading--leading hero__heading">Roaming</h1>
                    </div>
                </div>
                <nav class="breadcrumbs breadcrumbs--transparent">
                    <div class="spring">
                        <ol class="breadcrumbs__list hidden-xs">
                            <li class="breadcrumbs__item">
                                <router-link :to="{ name: 'main' }">Home</router-link>
                                <svg focusable="false" aria-hidden="true" class="icon icon--small breadcrumbs__chevron">
                                    <use xlink:href="#icon-chevron-right"></use>
                                </svg>
                            </li>
                            <li class="breadcrumbs__item">
                                <!-- <router-link :to="{ name: 'main'}">Întrebări frecvente</router-link> -->
                                <span class="breadcrumbs__crumb breadcrumbs__crumb--current">Întrebări frecvente</span>
                                <svg focusable="false" aria-hidden="true" class="icon icon--small breadcrumbs__chevron">
                                    <use xlink:href="#icon-chevron-right"></use>
                                </svg>
                            </li>
                            <li class="breadcrumbs__item">
                                <span v-html="question.title" class="breadcrumbs__crumb breadcrumbs__crumb--current"></span>
                            </li>
                        </ol>
                        <ol class="breadcrumbs__list visible-xs">
                            <li class="breadcrumbs__item">
                                <router-link :to="{ name: 'main' }">
                                    <svg focusable="false" aria-hidden="true" class="icon icon--small breadcrumbs__chevron">
                                        <use xlink:href="#icon-chevron-right"></use>
                                    </svg>
                                </router-link>
                                <router-link :to="{ name: 'main' }" v-html="question.title"></router-link>
                            </li>
                        </ol>
                    </div>
                </nav>
            </div>
            <div v-if="question" class="spring">
                <div class="section section--gallery bundle text-left">
                    <h1 v-html="question.title"></h1>
                    <div class="grid text-center">
                        <div v-if="question.content.postpaid && question.content.prepaid !== 'same'" class="grid__item grid__item--1/2 grid__item--sm-1/1 pad20 text-left">
                            <h2 class="heading heading--4 heading--light text-center">Abonament</h2>
                            <div v-html="question.content.postpaid"></div>
                        </div>
                        <div v-if="question.content.prepaid && question.content.prepaid !== 'same'" class="grid__item grid__item--1/2 grid__item--sm-1/1 pad20 text-left">
                            <h2 class="heading heading--4 heading--light text-center">Cartelă</h2>
                            <div v-html="question.content.prepaid"></div>
                        </div>
                        <div v-if="question.content.postpaid && question.content.prepaid == 'same'" class="grid__item grid__item--3/4 grid__item--sm-1/1 pad20 text-left">
                            <div v-html="question.content.postpaid"></div>
                        </div>
                        <div v-if="question.content.postpaid && question.content.prepaid == 'same'" class="grid__item grid__item--1/1 grid__item--sm-1/1 pad20 text-left">
                            <div v-if="hasCalculator">
                                <br />
                                <calculator></calculator>
                            </div>
                        </div>
                        <div v-if="question.content.fullwidth" class="grid__item grid__item--1/1 grid__item--sm-1/1 pad20 text-left">
                            <div v-html="question.content.fullwidth"></div>
                        </div>
                    </div>
                    <!-- <download-as-pdf></download-as-pdf> -->
                    <br />
                    <br />
                    <feedback view="full"></feedback>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Calculator from './Calculator';
import DownloadAsPdf from './DownloadAsPdf.vue';

export default {
    name: 'Detalii',
    components: {
        Calculator,
        DownloadAsPdf,
    },
    data() {
        return {
            hasCalculator: this.$route.params.questionName === 'ce-inseamna-politica-de-utilizare-rezonabila',
        };
    },
    computed: {
        question() {
            var question = this.$root.questions.find((item) => item.name === this.$route.params.questionName);
            if (!question) {
                this.$router.replace({ name: 'main' });
                return {};
            }
            return question;
        },
    },
};
</script>
